/**
 * An enum representing the way the collection utility determines uniqueness
 */
export enum UniqueMode {
  /** Use the object's ID to determine uniqueness */
  Id,

  /** Use the object's properties to determine uniqueness */
  Object
}
